import React from 'react'
import {Text, Checkbox as FormCheckbox} from 'react-form'
import {Form, Col, FormGroup, Button, ControlLabel, Row} from 'react-bootstrap'
import './UserForm.css'
import {Link} from 'react-router'
import ProgressBar from '../Common/ProgressBar/ProgressBar'

export default ({submitForm, getTouched, getError, isLoading}) => {
  return (
    <Form horizontal onSubmit={submitForm}>
      <Row className="FormWrapper">
        <Col lg={4} lgOffset={4} md={6} mdOffset={3} sm={8} smOffset={2} xs={12} xsOffset={0} className="Box">
          <h1 className="FormTitle">ثبت نام</h1>
          <FormGroup>
            <Col componentClass={ControlLabel} xs={4} >
              نام کاربری
            </Col>
            <Col xs={7}>
              <Text
                field="username"
                placeholder="نام کاربری"
                className="form-control"
                />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} xs={4} >
              رمز عبور
            </Col>
            <Col xs={7}>
              <Text
                field="password"
                type="password"
                placeholder="رمز عبور"
                className="form-control"
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} xs={4} >
              ایمیل
            </Col>
            <Col xs={7}>
              <Text
                field="email"
                type="email"
                placeholder="مثلا ali@yahoo.com"
                className="form-control"
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col componentClass={ControlLabel} xs={4} >
              شماره موبایل
            </Col>
            <Col xs={7}>
              <Text
                field="mobile"
                type="phone"
                placeholder="شماره موبایل"
                className="form-control"
              />
            </Col>
          </FormGroup>

          <FormGroup>
            <Col xsOffset={4} xs={8}>
              <span className="inline-checkbox">
                <FormCheckbox
                  field="terms"
                  showErrors={false}
                  placeholder="قوانین را می پذیرم"
                />
                <Link to={'/page/terms-of-service'}><span>قوانین را می پذیرم</span>{' '}</Link>
                <div className="FormError">{getTouched('terms') && getError('terms')}</div>
              </span>

            </Col>
          </FormGroup>

          <FormGroup>
            <Col xsOffset={4} xs={7}>
              <Button type="submit" className={`btnBlock ${isLoading && 'disabled'}`} bsStyle="success">
                ثبت نام
              </Button>
              <ProgressBar isLoading={isLoading} type="button" />
            </Col>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./src/components/Signup/UserForm.js